module.exports = __webpack_public_path__ + "assets/img/EXPOSE_API_PLUGIN.9d2572d6.svg";